var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-col',{staticClass:"mt-2",attrs:{"span":24}},[_c('GmapMap',{ref:"mapRef",staticClass:"mapWrapper",staticStyle:{"width":"500px","height":"300px"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"map-type-id":"roadmap"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }